import { render } from "./NoData.vue?vue&type=template&id=644fa6e8&scoped=true"
import script from "./NoData.vue?vue&type=script&lang=js"
export * from "./NoData.vue?vue&type=script&lang=js"

import "./NoData.vue?vue&type=style&index=0&id=644fa6e8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-644fa6e8"],['__file',"src/containers/components/performanceItem/NoData.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "644fa6e8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('644fa6e8', __exports__)) {
    api.reload('644fa6e8', __exports__)
  }
  
  module.hot.accept("./NoData.vue?vue&type=template&id=644fa6e8&scoped=true", () => {
    api.rerender('644fa6e8', render)
  })

}


export default __exports__